import React from 'react';
import { Card } from '../../../ui/molecules/Card';
import { Text } from '../../../ui/atoms/Text';
import { SectionHeader } from '../../../ui/molecules/SectionHeader';
import type { EducationItem } from '../resume.types';

type EducationSectionProps = {
  education: EducationItem[];
  languages: string[];
};

export function EducationSection({ education, languages }: EducationSectionProps) {
  return (
    <section className="px-4 py-16 dark:bg-stone-900" aria-labelledby="education-heading">
      <div className="mx-auto max-w-4xl">
        <SectionHeader
          id="education-heading"
          title="Education & languages"
          subtitle=""
        />
        <div className="grid gap-6 sm:grid-cols-2">
          {education.map((item, index) => (
            <Card key={item.id} animationDelay={index * 80}>
              <Text as="h3" variant="h3" className="mb-1">
                {item.institution}
              </Text>
              <Text variant="body" className="font-medium text-emerald-700 dark:text-emerald-400">
                {item.degree}
              </Text>
              <Text variant="muted" className="mt-2">
                {item.period}
              </Text>
            </Card>
          ))}
        </div>
        <div className="mt-8">
          <h3 className="font-display text-lg font-semibold text-stone-800 dark:text-stone-100 mb-2">
            Languages
          </h3>
          <p className="text-stone-600 dark:text-stone-400">{languages.join(' · ')}</p>
        </div>
      </div>
    </section>
  );
}
